module.exports = __webpack_public_path__ + "assets/loader.5d4e7d5eca90efc08918c9e2e5465512.gif";


//////////////////
// WEBPACK FOOTER
// ./img/loader.gif
// module id = 998
// module chunks = 0